import { useEffect, ReactNode } from 'react';
import { useAuthStore } from '../stores/authStore';
import { useMultiTabSync } from '../hooks/useMultiTabSync';
import { ToastContainer } from './Toast';

/**
 * AuthProvider component
 * Handles authentication initialization and multi-tab sync
 * Validates: Requirements 4.1, 8.1-8.5, 10.1-10.4
 */

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const checkSession = useAuthStore((state) => state.checkSession);
  const isLoading = useAuthStore((state) => state.isLoading);

  // Initialize multi-tab synchronization
  useMultiTabSync();

  // Check session on mount
  useEffect(() => {
    console.log('[AuthProvider] Component mounted, calling checkSession');
    checkSession();
  }, [checkSession]);

  // Log loading state changes
  useEffect(() => {
    console.log('[AuthProvider] isLoading changed to:', isLoading);
  }, [isLoading]);

  // Show loading state while checking session
  if (isLoading) {
    console.log('[AuthProvider] Rendering loading spinner');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
          <p className="mt-4 text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  console.log('[AuthProvider] Rendering children (loading complete)');
  return (
    <>
      {children}
      <ToastContainer />
    </>
  );
}

export default AuthProvider;
